<template><section>

<h1>Dialog 对话框</h1>
<p>各类函数式调用的对话框，应对各种弹出框场景。该组件直接使用 vant dialog，有一部分基于 semPopup 再开发而成。</p>
<h2>普通消息框</h2>
<p>:::demo</p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"pug"</span>&gt;</span>
sem-button(@click="openInfoDialog") 打开消息弹窗
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="handlebars"><span class="xml">
  import { dialog } from '@seiue/uikit-mobile'

  export default {
    methods: {
      async openInfoDialog() {
        await dialog.info(
          '一个标题',
          '<span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>段落一<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>'
        )
      },
    },
  }
</span></span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
<p>:::</p>
<h2>警告框</h2>
<p>:::demo</p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"pug"</span>&gt;</span>
sem-button(@click="openAlertDialog") 打开警告框
sem-button(@click="openErrorDialog") 打开警告框2
sem-button(@click="openInfoErrorDialog") 打开警告框3
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">import</span> { dialog } <span class="hljs-keyword">from</span> <span class="hljs-string">'@seiue/uikit-mobile'</span>

  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-attr">methods</span>: {
      openAlertDialog() {
        dialog.alert(
          <span class="hljs-string">'账号已登出'</span>,
          <span class="hljs-string">'您已在其他网页退出登录或切换账号，我们将为您刷新页面。'</span>
        )
      },
    },
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
<p>:::</p>
<h2>选择框</h2>
<p>:::demo</p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"pug"</span>&gt;</span>
sem-button(@click="openSelectDialog") 打开选择框
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
</code></pre>
<p>:::</p>
<h2>确认框</h2>
<p>:::demo</p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"pug"</span>&gt;</span>
sem-button(@click="openConfirmDialog1") 确认框
sem-button(
  type="danger",
  @click="openConfirmDialog2",
) 危险确认框
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">import</span> { dialog } <span class="hljs-keyword">from</span> <span class="hljs-string">'@seiue/uikit-mobile'</span>

  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-attr">methods</span>: {
      <span class="hljs-keyword">async</span> openConfirmDialog1() {
        <span class="hljs-keyword">const</span> result = <span class="hljs-keyword">await</span> dialog.confirm(
          <span class="hljs-string">'确定提交教务审核？'</span>,
          <span class="hljs-string">'撤回后相关教师将看不到此条申请'</span>
        )
        alert(result)
      },

      openConfirmDialog2() {
        dialog.confirm(<span class="hljs-string">'确定删除？'</span>, <span class="hljs-string">'删除后您的记录将无法恢复'</span>, {
          <span class="hljs-attr">danger</span>: <span class="hljs-literal">true</span>,
        })
      },
    },
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
<p>:::</p>
<h2>Alert</h2>
<p>警告框</p>
<p><code v-pre="">dialog.alert(title, message, options)</code></p>
<h3>Attribute</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
<th>可选值</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>标题，必填</td>
<td>string</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>message</td>
<td>内容</td>
<td>string</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>options</td>
<td><a href="https://youzan.github.io/vant/#/zh-CN/dialog">vant dialog options</a>均可用</td>
<td>Object</td>
<td>{}</td>
<td>-</td>
</tr>
</tbody>
</table>
<h2>Confirm</h2>
<p>确认框</p>
<p><code v-pre="">dialog.confirm(title, message, options)</code></p>
<h3>Attribute</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
<th>可选值</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>标题，必填</td>
<td>string</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>message</td>
<td>内容</td>
<td>string</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>options</td>
<td><a href="https://youzan.github.io/vant/#/zh-CN/dialog">vant dialog options</a>均可用</td>
<td>Object</td>
<td>{}</td>
<td>-</td>
</tr>
</tbody>
</table>
<h2>Info</h2>
<p>消息框，显示简单的消息</p>
<p><code v-pre="">dialog.info(title, content)</code></p>
<h3>Attribute</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
<th>可选值</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>标题，必填</td>
<td>string</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>content</td>
<td>内容，可接受富文本</td>
<td>string</td>
<td>-</td>
<td>-</td>
</tr>
</tbody>
</table>
<h2>Select</h2>
<p>单选弹出框，</p>
<h3>Attribute</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
<th>可选值</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>标题，必填</td>
<td>string</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>options</td>
<td>选项，必填。格式为 { label, name }</td>
<td>Array</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>setting</td>
<td>设置</td>
<td>Object</td>
<td>{}</td>
<td>-</td>
</tr>
<tr>
<td>setting.defaultValue</td>
<td>选项的默认选中值</td>
<td>number, string</td>
<td>''</td>
<td>-</td>
</tr>
<tr>
<td>setting.comment</td>
<td>选择框的注释</td>
<td>stirng</td>
<td>''</td>
<td>-</td>
</tr>
</tbody>
</table>
</section></template>
<style lang="sass" scoped>
.sem-button_lg
  margin-bottom: 5px
</style>
<script>
import { dialog } from '@seiue/uikit-mobile'

export default {
  data() {
    return {
      show: false,
      selectValue: '',
    }
  },

  methods: {
    openAlertDialog() {
      dialog.alert(
        '账号已登出',
        '您已在其他网页退出登录或切换账号，我们将为您刷新页面。'
      )
    },

    openErrorDialog() {
      dialog.error(
        '账号已登出',
        '您已在其他网页退出登录或切换账号，我们将为您刷新页面。',
        { confirmButtonLabel: '重新登陆' }
      )
    },

    openInfoErrorDialog() {
      dialog.infoError(
        '账号已登出',
        '您已在其他网页退出登录或切换账号，我们将为您刷新页面。',
        { confirmButtonLabel: '我知道了' }
      )
    },

    async openConfirmDialog1() {
      const result = await dialog.confirm(
        '确定提交教务审核？',
        '撤回后相关教师将看不到此条申请'
      )
      // eslint-disable-next-line
      console.log(result)
    },

    openConfirmDialog2() {
      dialog.confirm('确定删除？', '删除后您的记录将无法恢复', { danger: true })
    },

    async openInfoDialog() {
      await dialog.info(
        '一个标题',
        '<p>段落一</p><p>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二</p><p>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二</p><p>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二</p><p>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二</p><p>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二</p><p>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二</p><p>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二</p><p>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二</p><p>段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二段落二</p>'
      )
    },

    async openSelectDialog() {
      this.selectValue = await dialog.select(
        '标题',
        [
          {
            label: '微动画2',
            value: 1,
          },
          {
            label: '《古文观止》1班',
            value: 2,
          },
          {
            label: '艺术体操初级',
            value: 3,
          },
          {
            label: '化学选修4（基础）',
            value: 4,
          },
        ],
        {
          comment: 'hehe',
          defaultValue: this.selectValue,
        }
      )
    },
  },
}
</script>